var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.listTitle } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage ml-3 mr-3" },
          [
            _c(
              "b-row",
              { staticClass: "justify-content-start mb-5" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "text-xl-center mb-3",
                    attrs: { cols: "12", lg: "12", xl: "12" },
                  },
                  [
                    _c(
                      "b-button-group",
                      {
                        staticClass: "mt-3 mt-sm-0",
                        staticStyle: {
                          display: "grid",
                          "grid-auto-flow": "column",
                        },
                      },
                      _vm._l(_vm.tabs, function (tab, index) {
                        return _c(
                          "b-button",
                          {
                            key: index,
                            staticClass: "responsive-button",
                            attrs: {
                              variant:
                                _vm.tabName === index ? "primary" : "secondary",
                            },
                            on: {
                              click: function ($event) {
                                _vm.tabName = index
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t(tab.translationKey)) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "4", lg: "2", xl: "2" } },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btnFilter",
                        on: {
                          click: function ($event) {
                            _vm.displayFilter = !_vm.displayFilter
                          },
                        },
                      },
                      [
                        _vm.displayFilter
                          ? _c("i", { staticClass: "fa-light fa-minus" })
                          : _c("i", { staticClass: "fa-light fa-plus" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("filter.fltr")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "4", lg: "2", xl: "2" } },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btnFilter",
                        attrs: {
                          disabled:
                            _vm.activateSpinnerVopHistory ||
                            _vm.activateSpinnerVopMessage ||
                            _vm.activateSpinnerVopResponse,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onRefresh()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-light fa-rotate-right fs-14px",
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("common.rfrsh")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                staticClass: "min-w-100 justify-content-start",
                class: {
                  "filter-item-section": true,
                  "d-none": !_vm.displayFilter,
                },
              },
              [
                _vm.tabName != 0 && !_vm.flagBPCE
                  ? _c(
                      "b-col",
                      {
                        staticClass: "filter-item mb-5",
                        attrs: { sm: "6", lg: "3", cols: "12" },
                      },
                      [
                        _c("label", { attrs: { for: "monitoring-status" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("common.monitoring.status_type")) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.StatusType,
                                expression: "StatusType",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { id: "monitoring-status" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.StatusType = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _c(
                              "option",
                              { attrs: { value: "", disabled: "" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "common.monitoring.select_placeholder"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "ALL" } }, [
                              _vm._v(_vm._s(_vm.$t("common.monitoring.all"))),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "DDV" } }, [
                              _vm._v(
                                _vm._s(_vm.$t("common.monitoring.ddv_status"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "DDD" } }, [
                              _vm._v(
                                _vm._s(_vm.$t("common.monitoring.ddd_status"))
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "filter-item mb-5",
                    attrs: { sm: "6", lg: "3", cols: "12" },
                  },
                  [
                    _c("datetime-picker-custom", {
                      staticClass: "z-1",
                      class: {
                        "filter-item-input": true,
                        "filter-item-input-complete": _vm.dateStart,
                      },
                      attrs: {
                        format: "DD/MM/YYYY H:i:s",
                        inputLabel: _vm.$t("common.monitoring.date_start"),
                        customInputParentClass: "filter-item-content",
                        customInputClass: "w-100",
                        maxLength: 19,
                        placeholderValue: _vm.$t(
                          "common.datetime_picker_empty_date"
                        ),
                        inputIcon: "fa-solid fa-calendar",
                      },
                      model: {
                        value: _vm.dateStart,
                        callback: function ($$v) {
                          _vm.dateStart = $$v
                        },
                        expression: "dateStart",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "filter-item mb-5",
                    attrs: { sm: "6", lg: "3", cols: "12" },
                  },
                  [
                    _c("datetime-picker-custom", {
                      staticClass: "z-1",
                      class: {
                        "filter-item-input": true,
                        "filter-item-input-complete": _vm.dateEnd,
                      },
                      attrs: {
                        format: "DD/MM/YYYY H:i:s",
                        inputLabel: _vm.$t("common.monitoring.date_end"),
                        customInputParentClass: "filter-item-content",
                        customInputClass: "w-100",
                        maxLength: 19,
                        placeholderValue: _vm.$t(
                          "common.datetime_picker_empty_date"
                        ),
                        inputIcon: "fa-solid fa-calendar",
                      },
                      model: {
                        value: _vm.dateEnd,
                        callback: function ($$v) {
                          _vm.dateEnd = $$v
                        },
                        expression: "dateEnd",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                staticClass: "justify-content-end",
                class: {
                  "filter-item-section": true,
                  "d-none": !_vm.displayFilter,
                },
              },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "mt-4",
                    attrs: { sm: "4", lg: "2", cols: "12" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "mr-3",
                        attrs: { size: "sm" },
                        on: { click: _vm.clearFilterFields },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("filter.clr_fltr_field")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "mt-4",
                    attrs: { sm: "4", lg: "2", cols: "12" },
                  },
                  [
                    _c(
                      "b-button",
                      { attrs: { size: "sm" }, on: { click: _vm.applyFilter } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("common.srch")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                staticClass: "justify-content-end",
                class: { "filter-item-section": true },
              },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "mt-4",
                    attrs: { sm: "4", lg: "2", cols: "12" },
                  },
                  [
                    _vm.listItemsResponse.length > 0 ||
                    _vm.listItemsMessage.length > 0 ||
                    _vm.listItemsHistory.length > 0
                      ? _c(
                          "div",
                          { staticClass: "d-flex justify-content-end mt-5" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "btnFilter_2 responsive-button2",
                                on: {
                                  click: function ($event) {
                                    return _vm.extractXLSX()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-light fa-upload fs-14px",
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "fab-label" }, [
                                  _vm._v(_vm._s(_vm.$t("common.extract_page"))),
                                ]),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tabs",
              {
                attrs: { "nav-class": "d-none" },
                on: { input: _vm.onTabChange },
                model: {
                  value: _vm.tabName,
                  callback: function ($$v) {
                    _vm.tabName = $$v
                  },
                  expression: "tabName",
                },
              },
              [
                _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t(
                        "common.monitoring.distribution_vop_response_status"
                      ),
                    },
                  },
                  [
                    _c(
                      "b-row",
                      { staticClass: "justify-content-center mt-5" },
                      [
                        _vm.activateSpinnerVopResponse
                          ? _c("spinner")
                          : _vm.pieChartDataStatus
                          ? _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("h3", { staticClass: "text-center" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "common.monitoring.distribution_vop_response_status"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("pie-chart", {
                                  ref: "pieChartStatus",
                                  attrs: {
                                    "chart-data": _vm.pieChartDataStatus,
                                    options: _vm.chartOptionsStatus,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t(
                        "common.monitoring.time_distribution_by_processing_connector"
                      ),
                    },
                  },
                  [
                    _c(
                      "b-row",
                      { staticClass: "justify-content-center mt-5" },
                      [
                        _vm.activateSpinnerVopHistory
                          ? _c("spinner")
                          : _vm.pieChartDataConnector
                          ? _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("h3", { staticClass: "text-center" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "common.monitoring.time_distribution_by_processing_connector"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("pie-chart", {
                                  ref: "pieChartConnector",
                                  attrs: {
                                    "chart-data": _vm.pieChartDataConnector,
                                    options: _vm.chartOptionsConnector,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t(
                        "common.monitoring.distribution_of_requests"
                      ),
                    },
                  },
                  [
                    _c(
                      "b-row",
                      { staticClass: "justify-content-center mt-5" },
                      [
                        _vm.activateSpinnerVopMessage
                          ? _c("spinner")
                          : _vm.pieChartDataRequest
                          ? _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("h3", { staticClass: "text-center" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "common.monitoring.distribution_of_requests"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("pie-chart", {
                                  ref: "pieChartRequest",
                                  attrs: {
                                    "chart-data": _vm.pieChartDataRequest,
                                    options: _vm.chartOptionsRequest,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t(
                        "common.monitoring.average_duration_per_processing_step_messages"
                      ),
                    },
                  },
                  [
                    _c(
                      "b-row",
                      { staticClass: "justify-content-center mt-5" },
                      [
                        _vm.activateSpinnerVopHistory
                          ? _c("spinner")
                          : _vm.lineChartData
                          ? _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("h3", { staticClass: "text-center" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "common.monitoring.average_duration_per_processing_step_messages"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("line-chart", {
                                  ref: "lineChart",
                                  attrs: {
                                    "chart-data": _vm.lineChartData,
                                    options: _vm.chartOptionsLine,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }